import React, { ReactNode, SetStateAction, useState } from "react";
import { useAppContext } from "../../App";

type CustomAnchorProps = {
  children: ReactNode;
  classname: string;
  path: string;
  openOverlay?:
    | {
        path: string;
        title?: string;
        type: string;
      }
    | undefined;
};

function CustomAnchor({
  children,
  classname,
  path,
  openOverlay,
}: CustomAnchorProps) {
  const appContext = useAppContext();
  const [overlay, setOverlay] = useState<SetStateAction<boolean>>(false);
  const openOverlayModal = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (openOverlay) {
      e.preventDefault();
      appContext?.setViewFile(openOverlay);
      setOverlay(!overlay);
    }
  };

  return (
    <a className={classname} href={path} onClick={openOverlayModal}>
      {children}
    </a>
  );
}

export default CustomAnchor;
